import React from 'react';
import { GrafanaFaro } from '../../../instrumentation/grafanaFaro';
import { ViewName } from '../../../instrumentation/views';
import { ComponentErrorBoundary } from './ComponentErrorBoundary';
import { FullPageErrorFallback } from './Fallbacks/FullPageErrorFallback';

type Props = {
  viewName: ViewName;
  children: React.ReactNode;
};

export function PageErrorBoundary({ viewName, children }: Props) {
  GrafanaFaro.useSetMetaData({ viewName });
  return (
    <ComponentErrorBoundary errorContext={{ viewName }} FallbackComponent={FullPageErrorFallback}>
      {children}
    </ComponentErrorBoundary>
  );
}
